import { formatDate } from '@angular/common';
import { CmpsPeriodCompareType } from '@cmps/ng-kit';
import subDays from 'date-fns/subDays';

import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { PeriodType } from '../../widget/date-range.widget.model';
import { CacheDate } from '../models/cache-model';
import { PeriodCompareData } from '../models/period-compare-dialog.model';
import { PerformancePeriodCompare } from '../models/period-compare.model';

export function getPeriodCompareDialogData(
    data: PerformancePeriodCompare,
): PeriodCompareData[] {
    if (data == null) {
        return [];
    }

    const periodData: PeriodCompareData[] = [];
    data.periodTypes.forEach((e) => {
        const value: PeriodCompareData = {
            periodType: e,
            cacheDates: data.cacheDates?.filter((ee) => ee.periodType === e),
        };

        const periodLimitDate = subDays(new Date(), 89);
        switch (e) {
            case CmpsPeriodCompareType.DAYS:
                value.cacheDates = value.cacheDates
                    ?.filter(
                        (ee) =>
                            new Date(ee.endDate).getTime() >=
                            periodLimitDate.getTime(),
                    )
                    .map((val) => {
                        const date = new Date(val.endDate);
                        const transformedDate = {
                            day: date.getDate(),
                            month: date.getMonth() + 1,
                            year: date.getFullYear(),
                        };
                        return {
                            ...val,
                            date: transformedDate,
                            options: transformDate(val, PeriodType.DAY),
                        };
                    });
                break;
            case CmpsPeriodCompareType.WEEKS:
                value.cacheDates = value.cacheDates?.map((val) => {
                    return {
                        ...val,
                        options: transformDate(val),
                    };
                });
                break;
            case CmpsPeriodCompareType.MONTHS:
                value.cacheDates = value.cacheDates?.map((val) => {
                    return {
                        ...val,
                        options: transformDate(val),
                    };
                });
                break;
        }

        periodData.push(value);
    });

    return periodData;
}

export function transformDate(
    value: CacheDate,
    periodType?: PeriodType,
): string {
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);
    const userLocale = i18nService.locale;
    const endDateFormatted = formatDate(
        new Date(value.endDate),
        'MMMM d, YYYY',
        userLocale,
    );
    if (periodType === PeriodType.DAY) {
        return `${endDateFormatted}`;
    } else {
        const startDateFormatted = formatDate(
            new Date(value.startDate),
            'MMMM d, YYYY',
            userLocale,
        );
        return `${startDateFormatted} - ${endDateFormatted}`;
    }
}
